<template>
  <nav
    v-if="totalPages > 1"
    class="flex items-center justify-center gap-1 sm:gap-2 mt-10"
    aria-label="Paginación"
  >
    <button
      @click="changePage(currentPage - 1)"
      :disabled="currentPage === 1"
      class="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-full text-gray-400 hover:text-white disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
      aria-label="Página anterior"
    >
      <IconFbochas name="chevron-left" :size="20" />
    </button>

    <template v-for="(item, idx) in visiblePages" :key="idx">
      <span v-if="item === '...'" class="text-gray-500 px-1">…</span>
      <button
        v-else
        @click="changePage(item)"
        :class="[
          'w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-full text-sm sm:text-base font-medium transition-colors',
          currentPage === item
            ? 'bg-bochas-rojo text-white'
            : 'text-gray-400 hover:text-white',
        ]"
        :aria-current="currentPage === item ? 'page' : undefined"
      >
        {{ item }}
      </button>
    </template>

    <button
      @click="changePage(currentPage + 1)"
      :disabled="currentPage === totalPages"
      class="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-full text-gray-400 hover:text-white disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
      aria-label="Página siguiente"
    >
      <IconFbochas name="chevron-right" :size="20" />
    </button>
  </nav>
</template>

<script setup>
import { computed } from "vue";
import IconFbochas from "@/components/Icons/IconFbochas.vue";

const props = defineProps({
  currentPage: { type: Number, required: true },
  totalItems: { type: Number, required: true },
  perPage: { type: Number, default: 6 },
  scrollToTop: { type: Boolean, default: true },
});

const emit = defineEmits(["change"]);

const totalPages = computed(() =>
  Math.max(1, Math.ceil(props.totalItems / props.perPage))
);

const visiblePages = computed(() => {
  const total = totalPages.value;
  const current = props.currentPage;
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  if (current <= 4) return [1, 2, 3, 4, 5, "...", total];
  if (current >= total - 3)
    return [1, "...", total - 3, total - 2, total - 1, total];
  return [1, "...", current - 1, current, current + 1, "...", total];
});

function changePage(page) {
  if (page < 1 || page > totalPages.value || page === props.currentPage) return;
  emit("change", page);
  if (props.scrollToTop) {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}
</script>
